import { get, merge } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { isVisible } from 'resolvers/getVisibleEntities';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsHeaderFamilyUnitWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsHeaderFamilyUnitWidgetService } from 'services/memberDetailsHeaderFamilyUnitWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsHeaderFamilyUnitWidgetService = new MemberDetailsHeaderFamilyUnitWidgetService();
 * const result = await memberDetailsHeaderFamilyUnitWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsHeaderFamilyUnitWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsHeaderFamilyUnitWidgetService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );
        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                        callType,
                        callerType,
                    }
                } ),
            } );

            // extract component data
            const visibility = get( response, 'body.component.visibility', {} );
            const options = get( response, 'body.component.data.options', {} );
            const members = get( response, 'body.component.data.state.members', [] );
            const switchUserAction = get( response, 'body.component.structure.switchUserAction', [] );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: {
                    options,
                    members,
                    switchUserAction: isVisible( switchUserAction, visibility ) ? switchUserAction : null,
                }
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
